import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import { showToast } from '../Toast/Toast';
import CustomButton from '../CustomButton';
import './PrivateContentRequestModal.css';

const PrivateContentRequestModal = ({ show, onHide, userName }) => {
  const [step, setStep] = useState(1); // 1: Confirmation, 2: Success
  const [requesting, setRequesting] = useState(false);

  const handleConfirm = async () => {
    try {
      setRequesting(true);
      
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // TODO: Add API call here when ready
      // const response = await sendPrivateContentRequest(userId);
      
      setStep(2);
    } catch (error) {
      console.error('Error sending private content request:', error);
      showToast(error.message || 'Failed to send request', 'error');
    } finally {
      setRequesting(false);
    }
  };

  const handleCancel = () => {
    setStep(1);
    onHide();
  };

  const handleSuccessClose = () => {
    setStep(1);
    onHide();
  };

  const renderConfirmationStep = () => (
    <div className="private-content-modal-content">
      <div className="private-content-icon-wrapper">
        <FaExclamationCircle className="private-content-icon" />
      </div>
      <h4 className="private-content-modal-title">Send Request for Private Content</h4>
      <p className="private-content-modal-question">
        Are you sure you want to send a request for private content to <strong>{userName || 'this user'}</strong>?
      </p>
      <div className="private-content-modal-buttons">
        <CustomButton
          onClick={handleConfirm}
          disabled={requesting}
          className="private-content-yes-btn"
        >
          {requesting ? 'Sending...' : 'Yes'}
        </CustomButton>
        <CustomButton
          onClick={handleCancel}
          variant="secondary"
          className="secondaryButton"
        >
          No
        </CustomButton>
      </div>
    </div>
  );

  const renderSuccessStep = () => (
    <div className="private-content-modal-content">
      <div className="success-icon-wrapper">
        <FaCheckCircle className="success-icon" />
      </div>
      <h4 className="private-content-modal-title">Successful</h4>
      <p className="success-message">
        Your request for private content has been sent to {userName || 'the user'} successfully!
      </p>
      <div className="private-content-form-buttons">
        <CustomButton
          onClick={handleSuccessClose}
          className="private-content-ok-btn"
        >
          Ok
        </CustomButton>
      </div>
    </div>
  );

  return (
    <Modal show={show} onHide={handleCancel} centered className="private-content-request-modal">
      <Modal.Body className="private-content-modal-body">
        <button className="modal-close-btn" onClick={handleCancel}>
          <FaTimes />
        </button>
        
        {step === 1 && renderConfirmationStep()}
        {step === 2 && renderSuccessStep()}
      </Modal.Body>
    </Modal>
  );
};

export default PrivateContentRequestModal;

